/**
 * The permission strings `server/internal/cash/handler_ic_instrument.go` declares.
 *
 *  - `cash.ic_instrument.read` — list, get and the loan register report.
 *  - `cash.ic_instrument.manage` — create, edit a draft, submit, close.
 *
 * `cash.ic_instrument.approve` exists too, but there is no approve route here:
 * submit raises an approval-engine request and the decision is taken in the
 * approvals inbox, by someone other than whoever drafted or submitted it.
 */

export const IC_INSTRUMENT_PERMISSIONS = {
  read: 'cash.ic_instrument.read',
  manage: 'cash.ic_instrument.manage',
  companyRead: 'org.company.read',
} as const
